module.exports = __webpack_public_path__ + "img/true.e9cd3292.svg";